import React, {useState} from 'react';
import Autosuggest from 'react-autosuggest';

import './AutoSuggestInput.css'


const AutoSuggestInput = ({id, type, label , onChange , suggestionArray, 
    placeholder, inputValue, disabled, pholder, onfocus, onblur, onclick}) => {
        
    const [suggestions, setSuggestions] = useState([]);

    const getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();

        const inputLength = inputValue.length;
  
    return inputLength === 0 ? [] : suggestionArray.filter(lang =>
        lang.name.toLowerCase().slice(0, inputLength) === inputValue
    ).slice(0,7);
    };
  
    const getSuggestionValue = suggestion => suggestion.name;
  
    const renderSuggestion = suggestion => (
    
    <div>
        {suggestion.name}
    </div>
    );

    // Autosuggest will call this function every time you need to update suggestions.
    const onSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(value))
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    const onSuggestionsClearRequested = () => {
        setSuggestions([])
    };

    const inputProps = {
        value: inputValue,
        placeholder: placeholder,
        onChange: onChange,
        type: type,
        disabled,
        pholder,
        onFocus: onfocus,
        onBlur: onblur,
        onClick: onclick
    };

    return (
    <div className={`form-control`}>  
      <label htmlFor={id}>{label}</label>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    </div>
    );
  }

export default AutoSuggestInput;
